import { render, staticRenderFns } from "./DashboardAdTable.vue?vue&type=template&id=54b2f7d4&"
import script from "./DashboardAdTable.vue?vue&type=script&lang=js&"
export * from "./DashboardAdTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports